import React, { createContext, useCallback, useEffect, useState } from 'react';
import Loading from '../components/Loading';

export const LoadingContext = createContext({
  loading: false,
  showLoading: () => {},
  hideLoading: () => {},
  setLoading: () => {}
});

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    let loaded = false;

    const handleLoad = () => {
      if (!loaded && mounted) {
        loaded = true;
        // küçük bir gecikme vererek daha güzel bir kapanış sağlıyoruz
        setTimeout(() => setLoading(false), 300);
      }
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad, { passive: true });
    }

    const fallback = setTimeout(handleLoad, 8000);

    return () => {
      mounted = false;
      window.removeEventListener('load', handleLoad);
      clearTimeout(fallback);
    };
  }, []);

  const showLoading = useCallback(() => setLoading(true), []);
  const hideLoading = useCallback(() => setLoading(false), []);

  return (
    <LoadingContext.Provider value={{ loading, showLoading, hideLoading, setLoading }}>
      {children}
      <Loading visible={loading} />
    </LoadingContext.Provider>
  );
};

